import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  vertical-align: text-top;\n'], ['\n  display: inline-block;\n  vertical-align: text-top;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ' font-weight: normal;\n  color: ', ';\n  margin-top: ', 'px;\n'], ['\n  ', ' font-weight: normal;\n  color: ', ';\n  margin-top: ', 'px;\n']);

import React, { Component } from 'react';
import styled from 'styled-components';
import { colors, gridSize, typography } from '@atlaskit/theme';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import SuccessIcon from '@atlaskit/icon/glyph/editor/success';

/**
    Displays a Validation Message for a Field, FieldGroup or Section
*/

var IconWrapper = styled.span(_templateObject);

var Error = function Error() {
  return React.createElement(
    IconWrapper,
    null,
    React.createElement(ErrorIcon, { size: 'small', role: 'presentation' })
  );
};
var Success = function Success() {
  return React.createElement(
    IconWrapper,
    null,
    React.createElement(SuccessIcon, { size: 'small', role: 'presentation' })
  );
};

var Message = styled.div(_templateObject2, typography.h200, function (props) {
  return props.invalid ? colors.R400 : colors.G400;
}, gridSize() / 2);

var ValidatorMessage = function (_Component) {
  _inherits(ValidatorMessage, _Component);

  function ValidatorMessage() {
    _classCallCheck(this, ValidatorMessage);

    return _possibleConstructorReturn(this, (ValidatorMessage.__proto__ || _Object$getPrototypeOf(ValidatorMessage)).apply(this, arguments));
  }

  _createClass(ValidatorMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          invalidMessage = _props.invalidMessage,
          validMessage = _props.validMessage,
          isInvalid = _props.isInvalid;

      // Validation state is invalid, valid or not validated (null)

      if (isInvalid) {
        return React.createElement(
          Message,
          { invalid: true },
          React.createElement(Error, null),
          invalidMessage
        );
        // If the field hasn't been validated yet then isInvalid will be undefined
      } else if (this.props.isInvalid !== undefined && validMessage && validMessage.length) {
        return React.createElement(
          Message,
          null,
          React.createElement(Success, null),
          validMessage
        );
      }
      return null;
    }
  }]);

  return ValidatorMessage;
}(Component);

ValidatorMessage.defaultProps = {
  invalidMessage: '',
  validMessage: '',
  isInvalid: undefined,
  type: 'field'
};
export default ValidatorMessage;